export type Region = 'England' | 'Scotland' | 'Wales' | 'NorthernIreland';

export function getRegionString(region: number): undefined | Region {
    const map: {[id: number]: Region} = {
        1: 'England',
        2: 'Scotland',
        3: 'Wales',
        4: 'NorthernIreland',
    }

    return map[region];
}
